export const PAN_LIMIT = 3000;

export const CANVAS_WIDTH = 1067;

export const PAGE_HEIGHT = 1489;

// Changing this value might lead to database
// migration of old data
export const DEFAULT_FONT_SIZE = 48;
